import { render } from "./UserTraining.vue?vue&type=template&id=22f43f58"
import script from "./UserTraining.vue?vue&type=script&lang=js"
export * from "./UserTraining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__